<div class="row bloccodati">
  <div labelTextInput class="col-sm-4" [typeLabel]="'date'"
		[labelInput]="'Data apertura'" [valueInput]="ctxBodyFascicolo.fascicolo.dataInizioFascicolo"></div>
	<div labelTextInput class="col-sm-4" [typeLabel]="'text'"
    [labelInput]="'Natura'"	[valueInput]="ctxBodyFascicolo.fascicolo.natura?.descrizione"></div>
  <!--<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Grado'"
       [valueInput]="ctxBodyFascicolo.fascicolo.grado ? ctxBodyFascicolo.fascicolo.grado.label : ''"></div>-->
<!--<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Numero/Anno ruolo'"
       [valueInput]="(ctxBodyFascicolo.fascicolo.numeroRuolo ? ctxBodyFascicolo.fascicolo.numeroRuolo : '')  + ((ctxBodyFascicolo.fascicolo.annoRuolo && ctxBodyFascicolo.fascicolo.numeroRuolo) ? '/' : '') + (ctxBodyFascicolo.fascicolo.annoRuolo ? ctxBodyFascicolo.fascicolo.annoRuolo : '')"></div>-->
  <!--<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Processo telematico'"
       [valueInput]="ctxBodyFascicolo.fascicolo.flagProcessoTelematico ? 'Si' : 'No'"></div>-->
</div>
<div class="row bloccodati">
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
		[labelInput]="'Foro'" [valueInput]="ctxBodyFascicolo.fascicolo.foro?.descrizione"></div>
	<div labelTextInput class="col-sm-4" [typeLabel]="'text'"
    [labelInput]="'Conciliazione'"	[valueInput]="ctxBodyFascicolo.fascicolo.conciliazione ? 'Si' : 'No'"></div>
</div>
<!--<ng-template [ngIf]="ctxBodyFascicolo.fascicolo.capofila || ctxBodyFascicolo.fascicolo.riunito">
  <div class="row container_fieldset">
    <fieldset class="form-group">
      <legend>Riunione dei giudizi</legend>
      <ng-template [ngIf]="ctxBodyFascicolo.fascicolo.capofila">
        <div labelTextInput class="col-sm-4 bloccodati"
             [typeLabel]="'text'" [labelInput]="'Capofila'"
             [valueInput]="ctxBodyFascicolo.fascicolo.capofila ? 'Si' : 'No'"></div>
      </ng-template>
      <ng-template [ngIf]="ctxBodyFascicolo.fascicolo.riunito">
        <div labelTextInput class="col-sm-4 bloccodati"
             [typeLabel]="'text'" [labelInput]="'Riunito'"
             [valueInput]="ctxBodyFascicolo.fascicolo.riunito ? 'Si' : 'No'"></div>
      </ng-template>
      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
           [labelInput]="'Data riunione'"
           [valueInput]="ctxBodyFascicolo.fascicolo.dataRiunioneGiudizio"></div>
      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Motivo riunione'"
           [valueInput]="ctxBodyFascicolo.fascicolo.motivoRiunioneGiudizio"></div>
    </fieldset>
  </div>
</ng-template>-->
<!---->
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
  <!-- 				<div labelTextInput class="col-sm-12 bloccodati" -->
  <!-- 					[typeLabel]="'text'" [labelInput]="'Note'" -->
  <!-- 					[valueInput]="ctxBodyFascicolo.fascicolo.note"></div> -->
</div>
